// extracted by mini-css-extract-plugin
export default {"starterScreen":"wk","starterImage":"xk","already":"yk","btnContainer":"zk","starterImageMobile":"Ak","starterTextContainWrapper":"Bk","controlX":"Ck","attrWrapper":"Ek","logoWrapper":"Fk","starterTextContain":"Gk","starterHeader":"Hk","starterBtn":"Ik","starterSecondaryBtn":"Jk","starterBanner":"Kk","logoWrapperMob":"Lk","mobileBtnContainer":"Mk"};
    if(module.hot) {
      // 1713996739654
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  